import isOpen from '@/helpers/isOpen.js'

const getters = {
  appIsLoading: state => state.appLoading,
  appLogo: state => state.appLogo,
  data: state => state.data,
  franquicias: state => state.franquicias,
  costoEnvioPorZona: state => state.costoEnvioPorZona,
  appLogoFranquicia: state => state.appLogoFranquicia,
  appCustomerPosition: state => state.customerPosition,
  appPreviousPage: state => state.previousPage,
  appFranquiciaSeleccionada: state => state.franquiciaSeleccionada,
  appCupon: state => state.cupon,
  /** True si la tienda está cerrada (bandera NegocioCerrado o fuera de horario). Usado para mostrar catálogo pero ocultar carrito. */
  tiendaCerrada: (state) => {
    const data = state.data
    if (!data) return false
    if (data.NegocioCerrado) return true
    if (!data.horarioRegular || !data.horarioRegular.dataOriginal) return false
    return !isOpen(data.horarioRegular.dataOriginal)
  }
}

export default getters
